var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckCirclePremium(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M10 0C4.477 0 0 4.477 0 10s4.477 10 10 10 10-4.477 10-10C19.994 4.48 15.52.006 10 0z",
    fill: "#ed7759"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.773 6.833l-5.704 7.741a.842.842 0 01-1.192.157l-4.074-3.257a.834.834 0 011.042-1.302l3.397 2.718 5.189-7.042a.833.833 0 111.342.985z",
    fill: "#fff"
  })));
}
export default __webpack_public_path__ + "static/media/check-circle-premium.85c9e766.svg";
export { SvgCheckCirclePremium as ReactComponent };